import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_CATEGORY = "listCategories";
export const GET_DETAIL_CATEGORY = "detailCategory";
export const SAVE_CATEGORY = "saveCategory";
export const UPDATE_CATEGORY = "updateCategory";
export const DELETE_CATEGORY = "deleteCategory";
export const UPLOAD_CATEGORY_IMAGE = "uploadCategory";
export const GET_DATA_SEARCH = "getDataSearch";
export const SET_DATA_SEARCH = "setDataSearch";

export const SET_LIST_CATEGORY = "setListCategory";
export const SET_DETAIL_CATEGORY = "setDetailCategory";


const state = {
    categories: [],
    category: {},
    dataSearch: []
};

const getters = {
    categories(state) {
        return state.categories;
    },
    categoryDetail(state) {
        return state.category;
    },

    dataSearch(state) {
        return state.dataSearch;
    },
};

const actions = {
    [GET_LIST_CATEGORY](context, payload) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_CATEGORY, payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_CATEGORY, data);
                    context.commit(SET_DATA_SEARCH, data.data);
                }
                resolve(data);
            });
        });
    },

    [GET_DATA_SEARCH](context, payload) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_CATEGORY_SEARCH, payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DATA_SEARCH, data.data.categories);
                }
                resolve(data);
            });
        });
    },

    [GET_DETAIL_CATEGORY](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_CATEGORY}/${id}`).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DETAIL_CATEGORY, data);
                }
                resolve(data);
            });
        });
    },
    [UPLOAD_CATEGORY_IMAGE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.UPLOAD_CATEGORY_IMAGE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [SAVE_CATEGORY](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_CATEGORY}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_CATEGORY](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_CATEGORY}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_CATEGORY](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_CATEGORY}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};

const mutations = {
    [SET_LIST_CATEGORY](state, data) {
       state.categories =  data.data
    },
    [SET_DETAIL_CATEGORY](state, data) {
        state.category = data.data;
    },

    [SET_DATA_SEARCH](state, data) {
        state.dataSearch = data
    }
    
};

export default {
    state,
    actions,
    mutations,
    getters
};